import { FaustProvider } from "./contexts/FaustContext";
import { IDELayout } from "./components/layout/IDELayout";
import { TooltipProvider } from "./components/ui/tooltip";
import { Toaster } from "./components/ui/sonner";

export function App() {
    return (
        <FaustProvider>
            <TooltipProvider delayDuration={400}>
                <IDELayout />
                <Toaster />
            </TooltipProvider>
        </FaustProvider>
    );
}
